import React from 'react';
import { FormGroup, Label, Input } from '../../../styles/components';

interface ApiKeyStepProps {
  apiKey: string;
  onApiKeyChange: (value: string) => void;
  providerName?: string;
}

export function ApiKeyStep({ 
  apiKey, 
  onApiKeyChange,
  providerName 
}: ApiKeyStepProps) {
  return (
    <>
      <div style={{ 
        marginBottom: '1rem', 
        padding: '1rem', 
        backgroundColor: '#f3f4f6', 
        borderRadius: '0.5rem' 
      }}>
        <p style={{ margin: 0, color: '#374151', fontSize: '0.875rem' }}>
          Enter the API key provided by {providerName || 'the card processor'}.
        </p>
      </div>
      <FormGroup>
        <Label htmlFor="apikey">API Key *</Label>
        <Input
          id="apikey"
          type="password"
          value={apiKey}
          onChange={(e) => onApiKeyChange(e.target.value)}
          placeholder="Enter API key"
        />
        <small style={{ color: '#6b7280', marginTop: '0.5rem', display: 'block' }}>
          The API key should be provided by your card processor. Keep it secure and do not share it.
        </small>
      </FormGroup>
    </>
  );
}